export default __webpack_public_path__ + "static/thema-2-cropped-3da04a9ff31006464066e3ddbe5e3db4.jpg";